import union from 'lodash/union';

import getClasses from './getClasses';

export default function addClasses(el, ...classes) {
  classes = union(classes, getClasses(el));
  el.setAttribute('class', classes.join(' '));
}
